/*
  search-strict.js — Lever / FutNation

  PROBLEMA (medido na loja, 31/07/2026)
  A busca da Shopify nao para nos produtos que casam. Quando os resultados
  literais acabam, a camada semantica completa a pagina com produto que nao
  tem o termo em campo nenhum — nem titulo, nem tag, nem SKU, nem descricao.

    "cruzeiro"  -> 55 produtos reais, 90 resultados, 37 intrusos
    "santos"    -> 40 produtos reais, 111 resultados, 59 intrusos

  Colocar "*" no termo forca casamento literal e desliga essa camada:

    "cruzeiro*" -> 55 resultados, 0 intrusos
    "santos*"   -> 41 resultados, 1 intruso
    "flamengo*" -> 107 resultados, 0 intrusos

  E o AND entre termos resolve a diluicao de busca com 2 palavras
  ("arsenal away" trazia 244 resultados porque aceitava qualquer "Away").

  FALLBACK
  O AND estrito zera quando um termo nao existe no catalogo — ex "corinthians
  feminina", porque os titulos sao em ingles ("Women"). Nesse caso a pagina
  se redireciona uma vez pro termo original. O parametro fb=1 evita loop.
*/

(function () {
  'use strict';

  var STOPWORDS = new Set([
    'do', 'da', 'de', 'dos', 'das', 'o', 'a', 'os', 'as', 'e', 'em', 'no', 'na', 'com', 'para',
    'the', 'of', 'for', 'and', 'in', 'on', 'with'
  ]);

  // respeita quem ja escreveu query avancada
  function jaEhAvancada(q) {
    return /["*]/.test(q) || /\b(AND|OR|NOT)\b/.test(q);
  }

  /*
    EXCECAO MEDIDA — nao e chute.
    Varredura de 31 termos de time (39-onde-piora.mjs, 31/07/2026): o curinga
    melhora ou empata em 30. Piora em um so:

        sao paulo   sem fix:  56 resultados,  7 intrusos
                    com fix:  97 resultados, 49 intrusos

    Nesse termo "sao*" e "paulo*" devolvem quase o mesmo conjunto de ~100
    produtos, entao o AND nao filtra nada. Nao identifiquei o mecanismo interno
    da Shopify que causa isso — nao e acento (gremio* acerta 35/35 com 31
    titulos acentuados) nem duas palavras (real madrid e manchester city
    funcionam). Ate saber a causa, esse termo passa sem transformacao.

    Pra revalidar depois de mexer no catalogo: node tmp/futnation-tags/39-onde-piora.mjs
  */
  var SEM_TRANSFORMACAO = [/\bsao\s+paulo\b/];

  /*
    MAPA TERMO -> COLECCAO  (gerado por tmp/futnation-tags/45-gerar-mapa.mjs)

    As coleccoes usam regra TITLE CONTAINS escrita a mao, por isso acertam
    sempre — enquanto a busca adivinha. Quando o termo digitado e exatamente uma
    dessas coleccoes, vai pra ela: lista exata, na ordem definida no admin, com
    os filtros da coleccao. Resolve tambem o ranking de acessorio antes de
    camisa, porque a ordem passa a ser a de voces.

    So entra coleccao DEDICADA ao termo. Time sem coleccao propria (Bahia,
    Fortaleza, Bragantino, Sport Recife, Avai) cai na busca normal de proposito
    — mandar pra brazilian-teams daria 632 produtos de todos os times.
  */
  var COLECAO_POR_TERMO = {
    'todos os patrocinios': 'todos-os-patrocinios', 'atletico paranaense': 'athletico-pr',
    'brazilian teams': 'brazilian-teams', 'rio de janeiro': 'rio-de-janeiro',
    'internacional': 'internacional', 'sao paulo f c': 'sao-paulo-f-c',
    'minas gerais': 'minas-gerais', 'athletico pr': 'athletico-pr',
    'corinthians': 'corinthians', 'atletico mg': 'atletico-mg',
    'real madrid': 'real-madrid', 'fluminense': 'fluminense', 'palmeiras': 'palmeiras',
    'sao paulo': 'sao-paulo-f-c', 'tracksuit': 'tracksuit', 'flamengo': 'flamengo',
    'cruzeiro': 'cruzeiro', 'kit kids': 'infantil', 'infantil': 'infantil',
    'botafogo': 'botafogo', 'keychain': 'keychain', 'torcedor': 'torcedor',
    'patches': 'patches', 'sticker': 'sticker', 'brazil': 'brazil', 'santos': 'santos',
    'jacket': 'jacket', 'gremio': 'gremio', 'mascot': 'mascot', 'treino': 'treino',
    'vasco': 'vasco', 'patch': 'patches', 'flag': 'flag', 'sul': 'sul',

    /*
      GRAFIA EM PORTUGUES. A loja e EN e os titulos usam "Brazil", mas o publico
      brasileiro digita "Brasil". Sem isso, "brasil*" casa por prefixo com as
      tags "Brasileiros" e "Brasileirao" e devolve 97 resultados dos quais so 1
      e do Brasil — medido em 49-brasil.mjs (88/88 dos errados tinham tag
      comecando com "brasileir").
    */
    'brasil': 'brazil', 'selecao brasileira': 'brazil', 'brasileirao': 'brazilian-teams',
    'gremio fbpa': 'gremio', 'sao paulo fc': 'sao-paulo-f-c', 'spfc': 'sao-paulo-f-c',
    'vasco da gama': 'vasco', 'atletico mineiro': 'atletico-mg', 'galo': 'atletico-mg',
    'timao': 'corinthians', 'coringao': 'corinthians', 'verdao': 'palmeiras',
    'peixe': 'santos', 'fogao': 'botafogo', 'tricolor carioca': 'fluminense',
    'colorado': 'internacional', 'raposa': 'cruzeiro'
  };

  // palavras que o cliente digita junto do time e nao mudam a intencao
  var RUIDO = ['camisa', 'camisas', 'jersey', 'shirt', 'time', 'futebol', 'soccer', 'do', 'da', 'de'];

  function colecaoPara(q) {
    var limpo = q.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ').split(/\s+/)
      .filter(function (w) { return w && RUIDO.indexOf(w) === -1; }).join(' ');
    return COLECAO_POR_TERMO[limpo] || null;
  }

  function transformar(q) {
    if (!q || jaEhAvancada(q)) return null;

    var limpo = q.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    for (var i = 0; i < SEM_TRANSFORMACAO.length; i++) {
      if (SEM_TRANSFORMACAO[i].test(limpo)) return null;
    }
    var termos = q.trim().toLowerCase().split(/\s+/)
      .filter(function (w) { return w && !STOPWORDS.has(w); })
      .map(function (w) { return w.replace(/[^\p{L}\p{N}-]/gu, ''); })
      .filter(function (w) { return w.length > 1; });
    if (!termos.length) return null;
    return termos.map(function (w) { return w + '*'; }).join(' AND ');
  }

  // ---------- 1. reescreve a busca no submit ----------
  function ligarForm(form) {
    if (form.dataset.strictSearch === 'on') return;
    form.dataset.strictSearch = 'on';

    form.addEventListener('submit', function (ev) {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var original = input.value;

      // 1) o termo e uma coleccao nossa? vai pra ela — lista exata e ordem definida
      var col = colecaoPara(original);
      if (col) {
        ev.preventDefault();
        window.location.href = '/collections/' + col;
        return;
      }

      // 2) senao, busca estrita
      var estrito = transformar(original);
      if (!estrito) return;

      var hidden = form.querySelector('input[name="q_orig"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'q_orig';
        form.appendChild(hidden);
      }
      hidden.value = original;
      input.value = estrito;

      // devolve o texto digitado ao campo — senao a query crua reaparece
      // quando a pessoa volta pela seta do navegador
      setTimeout(function () { input.value = original; }, 0);
    });
  }

  // ---------- 2. na pagina de resultados ----------
  function tratarResultados() {
    var url = new URL(window.location.href);
    if (!/\/search/.test(url.pathname)) return;

    // reconstroi o termo digitado a partir do proprio q — a paginacao do Dawn
    // descarta o q_orig, entao o campo mostrava "santos*" na pagina 2
    var q = url.searchParams.get('q') || '';
    var orig = url.searchParams.get('q_orig');
    if (!orig && (/\*/.test(q) || /\bAND\b/.test(q))) {
      orig = q.split(/\s+AND\s+/).map(function (w) { return w.replace(/\*$/, ''); }).join(' ');
    }
    if (!orig) return;

    // o campo e o titulo devem mostrar o que a pessoa digitou, nao "santos* AND x*"
    document.querySelectorAll('input[name="q"]').forEach(function (i) { i.value = orig; });
    document.querySelectorAll('h1, .title--primary').forEach(function (h) {
      if (h.textContent.indexOf('*') > -1) h.textContent = h.textContent.replace(/"[^"]*"/, '"' + orig + '"');
    });

    // busca estrita nao achou nada -> volta pro termo original, uma vez so
    if (url.searchParams.get('fb') === '1') return;
    var achou = document.querySelectorAll('a[href*="/products/"]').length;
    if (achou > 0) return;

    url.searchParams.set('q', orig);
    url.searchParams.delete('q_orig');
    url.searchParams.set('fb', '1');
    window.location.replace(url.toString());
  }

  function iniciar() {
    document.querySelectorAll('form[action*="/search"]').forEach(ligarForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciar(); tratarResultados(); });
  } else {
    iniciar();
    tratarResultados();
  }

  // header e drawer remontam via section rendering
  document.addEventListener('shopify:section:load', iniciar);
})();
